var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.304321,
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.804321,
    width: 29,
    height: 29,
    rx: 3.5,
    stroke: "#263BD4",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 16.471C15.6443 16.471 16.1666 15.9486 16.1666 15.3043C16.1666 14.66 15.6443 14.1376 14.9999 14.1376C14.3556 14.1376 13.8333 14.66 13.8333 15.3043C13.8333 15.9486 14.3556 16.471 14.9999 16.471Z",
    stroke: "#555555",
    strokeOpacity: 0.87,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6667 16.471C20.311 16.471 20.8333 15.9486 20.8333 15.3043C20.8333 14.66 20.311 14.1376 19.6667 14.1376C19.0223 14.1376 18.5 14.66 18.5 15.3043C18.5 15.9486 19.0223 16.471 19.6667 16.471Z",
    stroke: "#555555",
    strokeOpacity: 0.87,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3334 16.471C10.9777 16.471 11.5001 15.9486 11.5001 15.3043C11.5001 14.66 10.9777 14.1376 10.3334 14.1376C9.68908 14.1376 9.16675 14.66 9.16675 15.3043C9.16675 15.9486 9.68908 16.471 10.3334 16.471Z",
    stroke: "#555555",
    strokeOpacity: 0.87,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipses);
export default __webpack_public_path__ + "static/media/ellipses.4dbff8829d14ba4df0302016c958cd63.svg";
export { ForwardRef as ReactComponent };